import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { TFunction } from "i18next";
import { CommandBarButton, IButtonProps, Icon } from "office-ui-fabric-react";
import React from "react";
import { ReactComponent as FilterSettingsActiveIcon } from "../../assets/icons/filter-settings-active.svg";

type Props = IButtonProps & { isActive: boolean; t: TFunction };

export const ColumnOptionsButton = ({
  className,
  isActive,
  onClick,
  text,
  t
}: Props) => {
  return (
    <StyledCommandBarButton
      text={text ?? t("greco.columnOptions")}
      className={className}
      onClick={onClick}
      onRenderIcon={() => {
        return isActive ? (
          <FilterSettingsActiveIcon />
        ) : (
          <Icon
            iconName="FilterSettings"
            className={css`
              font-size: 15px;
            `}
          />
        );
      }}
    />
  );
};

const StyledCommandBarButton = styled(CommandBarButton)`
  height: 32px;
  border-radius: 2px;
  padding-left: 6px;
`;
